import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {CopilotChatEntitlementResult} from '@github-ui/copilot-entitlement/copilot-chat-entitlement'

export const useEntitlementData = ({enabled}: {enabled: boolean}) => {
  const {data} = useQuery<CopilotChatEntitlementResult>({
    queryKey: ['copilot-chat', 'entitlement'],
    queryFn: async () => {
      const response = await verifiedFetchJSON('/github-copilot/chat/entitlement')

      if (!response.ok) {
        throw new Error(`Failed to retrieve Copilot chat entitlement (${response.status} on ${response.url})`)
      }

      return (await response.json()) as CopilotChatEntitlementResult
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    plan: data?.plan,
    licenseType: data?.licenseType,
  }
}
